import { ButtonProps } from 'antd';
import { ExportButton } from '@ui/general/ExportButton';
import React from 'react';
import { coreActions } from '@sonar-software/sonar-core';
import { createAsyncSelectors } from '@lib/selectors';

export const exportStartSelectors = createAsyncSelectors((state) => state.core.initiatives.export.post);

export type InitiativeExportButtonProps = ButtonProps & {
	filters?: string;
	initiativeId: number;
};

export const InitiativeExportButton: React.FC<InitiativeExportButtonProps> = ({
	filters,
	initiativeId,
	disabled
}) =>
	<ExportButton
		buttonProps={ {
			id: 'initiative-export-button',
			type: 'default'
		} }
		disabled={ disabled }
		onStartExport={ coreActions.requestPostCoreInitiativesExport }
		request={ {
			filters: filters,
			initiativeId
		} }
		resetExport={ coreActions.resetPostCoreInitiativesExport }
		stateSelector={ exportStartSelectors.state } />;

